import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import Signin from "./components/auth/Signin";
import { Layout } from "./shared/Layout";
import RequireAuth from "./hooks/RequireAuth";
import MainContainer from "./components/mainContainer/MainContainer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import useAuth from "./hooks/useAuth";
import { messaging } from "./firebase";
import { getToken } from "firebase/messaging";
import ApplicationForm from "./components/forms/ApplicationForm";
import ForgotPassword from "./components/forgotpassword/ForgotPassword";
import JoinOrganisation from "./components/joinorganisation/JoinOrganisation";
import ResetPassword from "./components/auth/ResetPassword";

function App() {
  const { setAuth, setOrganisation } = useAuth();
  const [fcmToken, setfcmToken] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  async function requestPermission() {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      //generate
      const token = await getToken(messaging, {
        vapidKey:
          "BCOIVwxcIb3aPdVuIWo2TVEf1rVpnB3zL4ddxuC3biBuJZZOilCbnofuWa8PK4yv6KfRiVaEjszG_QAeB-ahS4E",
      });
      setfcmToken(token);
      console.log(token);
    } else if (permission === "denied") {
      alert("You denied for notification");
    }
  }

  useEffect(() => {
    requestPermission();
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    const user = localStorage.getItem("user");
    const savedOrganisation = localStorage.getItem("organisation");
    if (accessToken) {
      setAuth({
        user: JSON.parse(user),
        accessToken: accessToken,
        refreshToken: refreshToken,
      });
      if (savedOrganisation) {
        setOrganisation(JSON.parse(savedOrganisation));
      }
    }
    console.log(location.pathname);
    const publicPaths = ["/", "/signin", "/forgotpassword", "/join-organisation"];
    if (location.pathname === "/application-form") {
      navigate("/application-form", { replace: true });
    } else if (accessToken) {
      if (publicPaths.includes(location.pathname)) {
        navigate("/organisations", { replace: true });
      }
    } else if (location.pathname === "/") {
      // Signed out, at the root: go and sign in. Anywhere else is left exactly
      // as it was. This used to navigate to location.pathname, which drops the
      // query string -- so a reset link, /reset-password?token=..., arrived as
      // /reset-password and the page said the token was missing. Every emailed
      // reset link failed that way for anybody not already signed in.
      navigate("/signin", { replace: true });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/application-form" element={<ApplicationForm />}></Route>
          <Route
            path="/signin"
            element={<Signin fcmToken={fcmToken} />}
          ></Route>
          <Route path="/forgotpassword" element={<ForgotPassword />}></Route>
          {/* Where an invite link lands. Public: the whole point is that the
              person cannot sign in yet. */}
          <Route path="/join-organisation" element={<JoinOrganisation />}></Route>
          {/* Where a password reset link lands. Public, like the invite: the
              person using it cannot sign in, and the token is what authorises
              them. Without this route the link fell through to RequireAuth
              and bounced to /signin. */}
          <Route path="/reset-password" element={<ResetPassword />}></Route>
          <Route element={<RequireAuth />}>
            <Route path="/*" element={<MainContainer />}></Route>
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
